import React, {useEffect} from "react";
import {Redirect, Route, Switch, useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

//components:
import BasePage from "./BasePage";

//helpers:
import {sendDataLayer} from "./util/tagmanager";
import LoginWrapper from "./pages/Authentication/LoginWrapper";
import {loadParameter} from "./redux_slices/contextSlice";
import {setHeaderImg} from "./redux/Layout/layoutSlice";
import {AuthGuard} from "./wrappers/AuthGuard";
import LoginComponent from "./pages/Authentication/LoginComponent";

const Routes = props => {
    const history = useHistory();
    const dispatch = useDispatch();

    const contextSelector = useSelector(state => state.context);
    const contextStatus = useSelector(state => state.context.status);
    const credentialSelector = useSelector(state => state.context.credential);

    const canSeeHelpCrunch = true; //useSelector(state => checkPermission(state, `settings.viewMenuLink`)); //Comentat perque caldrà activar-ho en unes setmanes de nou
    const pageTitle = useSelector(state => loadParameter(state, "pageTitle"));
    const homePic = useSelector(state => loadParameter(state, "homePic"));

    const currentEnvironment = process.env.REACT_APP_APP_ENV;
    const hasTermsAndConditionsAccepted = credentialSelector?.termsAndConditions;

    useEffect(() => {
        dispatch(setHeaderImg(homePic));
    }, [contextStatus]);

    useEffect(() => {
        if (window.HelpCrunch) {
            if (!credentialSelector || !credentialSelector.termsAndConditions) {
                window.HelpCrunch("hideChatWidget");
            } else {
                const shouldShow = canSeeHelpCrunch && (currentEnvironment === "prod" || currentEnvironment === "stag");

                if (shouldShow) {
                    window.HelpCrunch("showChatWidget");
                } else window.HelpCrunch("hideChatWidget");
            }
        }
    }, [credentialSelector, hasTermsAndConditionsAccepted, canSeeHelpCrunch, currentEnvironment]);

    history.listen(location => {
        if (credentialSelector && credentialSelector.credential_id) {
            sendDataLayer(
                {
                    event: "routeChanged",
                },
                {context: contextSelector, location}
            );
        }
    });

    return (
        <Switch>
            <Route path={"/auth/login"}>
                {!contextSelector.credential ?
                    <LoginWrapper>
                        <LoginComponent redirect={true}/>
                    </LoginWrapper>
                    :
                    <Redirect to={'/'}/>
                }
            </Route>
            <Route>
                <AuthGuard redirection={true}>
                    <BasePage docTitle={pageTitle}/>
                </AuthGuard>
            </Route>
        </Switch>
    );
};

export default Routes;
